<template>
  <div class="mx-4 mt-2" id="push_settings">
    <h6>Beta feature: this will allow your compatible browser (tested with Chrome) to receive web push notifications
      from your trackers</h6>
    <p>The feature is currently limited to one browser per account(last wins)</p><br>

    <h5 class="text-danger font-weight-bold" v-if="!push_supported">Push notification not supported on this browser</h5>
    <p v-if="push_supported">
      <input type="checkbox" id="enable_push" v-model="isSubscribed" v-on:change="changeSubscription()">
      <label for="checkbox">Enable Push Messaging</label>
    </p>

  </div>
</template>


<script>

import {HTTP} from '../http-constants'

//todo: should be dynamic
const applicationServerPublicKey = "BNVq_StJ_ezYolVqpwEYSAr0IC0mfgFdrBR6EnM9N_xKEi2-9v73HCvU6-d5jwfqPrHTULk2_NUY8hpwgJNC6q0";

function urlB64ToUint8Array(base64String) {
  const padding = '='.repeat((4 - base64String.length % 4) % 4);
  const base64 = (base64String + padding)
      .replace(/\-/g, '+')
      .replace(/_/g, '/');

  const rawData = window.atob(base64);
  const outputArray = new Uint8Array(rawData.length);

  for (let i = 0; i < rawData.length; ++i) {
    outputArray[i] = rawData.charCodeAt(i);
  }
  return outputArray;
}

export default {
  name: 'PushNotif',
  data() {
    return {
      push_allowed: false,
      push_supported: false,
      isSubscribed: false,
      swRegistration: null,
    }
  },
  methods: {
    'getSubscription': function () {
      // Set the initial subscription value
      var self = this;
      self.swRegistration.pushManager.getSubscription()
          .then(function (subscription) {
            self.isSubscribed = !(subscription === null);
            self.updateSubscriptionOnServer(subscription);

            if (self.isSubscribed) {
              console.log('User IS subscribed.');
            } else {
              console.log('User is NOT subscribed.');
            }
          });
    },
    pushAllowed: function () {
      if (Notification.permission === 'denied') {
        this.push_allowed = false;
        return false;
      }

      this.push_allowed = true;
      return true;
    },

    'updateSubscriptionOnServer': function (subscription) {

      if (subscription == null) {
        subscription = "";
      }
      let info = JSON.stringify(subscription);
      console.log("Info" + info);

      var nVer = navigator.appVersion;
      var nAgt = navigator.userAgent;
      var browserName = navigator.appName;

      let web_device = {'subscription': subscription}
      HTTP.post('/devices/web/?profile=tracker', web_device)
          .then(function (re) {
            var device = re.data;
          })
          .catch(function (error) {
            console.log(error);
          });
    },
    'unsubscribeUser': function () {
      var self = this;
      self.swRegistration.pushManager.getSubscription()
          .then(function (subscription) {
            if (subscription) {
              return subscription.unsubscribe();
            }
          })
          .catch(function (error) {
            console.log('Error unsubscribing', error);
          })
          .then(function () {
            self.updateSubscriptionOnServer(null);

            console.log('User is unsubscribed.');
            self.isSubscribed = false;
          });
    },
    'subscribeUser': function () {
      const applicationServerKey = urlB64ToUint8Array(applicationServerPublicKey);
      var self = this;
      self.swRegistration.pushManager.subscribe({
        userVisibleOnly: true,
        applicationServerKey: applicationServerKey
      })
          .then(function (subscription) {
            console.log('User is subscribed.');
            self.updateSubscriptionOnServer(subscription);
            self.isSubscribed = true;
          })
          .catch(function (err) {
            console.log('Failed to subscribe the user: ', err);
          });
    },
    'changeSubscription': function () {
      if (this.isSubscribed) {
        this.subscribeUser();
      } else {
        this.unsubscribeUser();
      }
    },
  },
  mounted: function () {
    if ('serviceWorker' in navigator) {
      console.log('Service Worker and Push is supported');

      let self = this;
      navigator.serviceWorker.register('/js/sw.js')
          .then(function (swReg) {
            console.log('Service Worker is registered', swReg);

            swReg.update();
            self.swRegistration = swReg;
            self.push_supported = true;
            self.getSubscription();
          })
          .catch(function (error) {
            console.error('Service Worker Error', error);
          });
    } else {
      console.warn('Push messaging is not supported');
      this.push_supported = false;

    }
  }
}

</script>
